// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l8A_","footer":"styles_footer__1c-Oo"};